import { MapPin, Compass, ShieldCheck, Trees, Map, ArrowRight } from "lucide-react";

const MAP_3D_URL = "https://realsanjose.mapioland.com/map/";

const POINTS = [
  { icon: Compass, title: "Conectividad", text: "Acceso directo a vías principales y rutas hacia la ciudad." },
  { icon: ShieldCheck, title: "Privacidad", text: "Entorno tranquilo, ideal para vivir en familia con seguridad." },
  { icon: Trees, title: "Naturaleza", text: "Paisajes abiertos rodeados de áreas verdes y aire limpio." },
];

export default function Location() {
  return (
    <section
      id="location"
      data-testid="location-section"
      className="py-24 md:py-32 bg-[#FAF9F6]"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
          {/* Map */}
          <div className="lg:col-span-7 relative">
            <div className="relative overflow-hidden rounded-md border border-[#DDD8CC]">
              <iframe
                title="Ubicación Lauburu — Real San José"
                src="https://www.google.com/maps?q=20.409069,-102.732400&z=15&output=embed"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                allowFullScreen
                data-testid="location-map-iframe"
                className="w-full h-[480px] md:h-[600px] block"
              />
            </div>
            <a
              href="https://maps.app.goo.gl/wkDtsiK56ehDJoTs5"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="location-card"
              className="absolute -bottom-6 -right-2 sm:right-6 bg-white border border-[#DDD8CC] p-6 max-w-xs shadow-sm hover:border-[#3E482A] transition-colors group"
            >
              <div className="flex items-center gap-2 text-[#3E482A] mb-2">
                <MapPin size={18} strokeWidth={1.6} />
                <span className="text-xs tracking-[0.25em] uppercase font-medium">
                  Cómo llegar
                </span>
              </div>
              <p className="font-heading text-xl font-light text-[#2D2920] leading-snug">
                Abrir ubicación en Google Maps
              </p>
              <span className="mt-3 inline-flex items-center gap-2 text-xs tracking-[0.2em] uppercase text-[#7a6f55] group-hover:text-[#3E482A]">
                Ver ruta
                <ArrowRight size={14} className="transition-transform group-hover:translate-x-1" />
              </span>
            </a>
          </div>

          {/* Text */}
          <div className="lg:col-span-5">
            <span className="text-xs tracking-[0.3em] uppercase text-[#7a6f55] font-medium">
              Donde queremos vivir
            </span>
            <h2 className="font-heading mt-4 text-4xl sm:text-5xl font-light tracking-tight text-[#2D2920] leading-[1.05]">
              Ubicación
              <br />
              <em className="italic font-extralight text-[#3E482A]">estratégica</em>.
            </h2>
            <p className="mt-6 text-lg text-[#5a5340] font-light leading-relaxed">
              Conectividad ideal y acceso rápido a vías principales, manteniendo
              la tranquilidad, privacidad y el contacto con la naturaleza que tu
              familia merece.
            </p>

            <a
              href={MAP_3D_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="location-map3d-btn"
              className="group mt-10 relative block overflow-hidden border border-[#3E482A] bg-[#3E482A] hover:bg-[#2D2920] text-white p-6 rounded-md transition-colors"
            >
              <div className="flex items-center justify-between gap-4">
                <div className="flex items-center gap-4">
                  <div className="shrink-0 w-12 h-12 rounded-full bg-[#79804D] flex items-center justify-center text-[#2D2920]">
                    <Map size={20} strokeWidth={1.8} />
                  </div>
                  <div>
                    <div className="text-xs tracking-[0.25em] uppercase text-[#79804D] font-medium">
                      Mapa interactivo 3D
                    </div>
                    <div className="font-heading text-lg font-light mt-1">
                      Explora lotes disponibles, precios y medidas
                    </div>
                  </div>
                </div>
                <ArrowRight
                  size={20}
                  className="shrink-0 transition-transform group-hover:translate-x-1"
                />
              </div>
            </a>

            <ul className="mt-10 space-y-6">
              {POINTS.map(({ icon: Icon, title, text }) => (
                <li
                  key={title}
                  className="flex gap-5 items-start"
                  data-testid={`location-point-${title.toLowerCase()}`}
                >
                  <div className="shrink-0 w-12 h-12 rounded-full border border-[#DDD8CC] flex items-center justify-center text-[#3E482A]">
                    <Icon size={20} strokeWidth={1.5} />
                  </div>
                  <div>
                    <div className="font-heading text-lg text-[#2D2920]">{title}</div>
                    <div className="text-[#5a5340] font-light leading-relaxed">{text}</div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
